import { MediaExtended } from '@app/models/media-extended';

export interface IMediaState {
  addedMedia: MediaExtended;
}

export const initialMediaState: IMediaState = {
  addedMedia: null
};
